import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { Col, Row } from 'react-grid-system';
import H1 from '../../atoms/title/H1';
import Panel from '../../atoms/Panel';
import Layout from '../../templates/Layout';
import H3 from '../../atoms/title/H3';
import FileUploader from '../../atoms/FileUploader';
import ClaimantInfo from '../../molecules/form/ClaimantInfo';
import CounterPartyInfo, { initialIndividualData, } from '../../molecules/form/CounterPartyInfo';
import Flex from '../../atoms/Flex';
import Invoices from '../../molecules/form/Invoices';
import Button from '../../atoms/Button';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import LegalPersons from '../../molecules/form/LegalPerson';
// @ts-ignore
import { useForm } from '@inertiajs/react';
import Notice from '../../molecules/Notice';
import { Helmet } from 'react-helmet';
const initialData = {
    type: 'individual',
    invoices: [],
    dossier_files: [],
    plaintiff_name: '',
    plaintiff_street: '',
    plaintiff_house_number: '',
    plaintiff_postal_code: '',
    plaintiff_city: '',
    plaintiff_country_code: 'NL',
    legal_company_name: '',
    legal_initials: '',
    legal_given_name: '',
    legal_insertion: '',
    legal_family_name: '',
    legal_email: '',
    legal_phone_number: '',
    legal_kvk_number: '',
    legal_origin_location: '',
    legal_street: '',
    legal_house_number: '',
    legal_postal_code: '',
    legal_country_code: 'NL',
    legal_remark: '',
    legal_client_number: '',
    individuals: [initialIndividualData],
};
const Create = ({ countryOptions }) => {
    const { data, setData, post, processing, errors, reset, } = useForm(initialData);
    const [errorNotice, setErrorNotice] = useState(null);
    const [recentlySuccessful, setRecentlySuccessful] = useState(false);
    const debtorsRef = useRef(null);
    const invoicesRef = useRef(null);
    const fileUploaderRef = useRef(null);
    /**
     * Invokes a hard reset on the repeater components, because Inertia can not (yet) deal with nested objects/arrays.
     */
    const handleReset = () => {
        debtorsRef?.current?.reset();
        invoicesRef?.current?.reset();
        fileUploaderRef?.current?.reset();
        reset();
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        try {
            post(window.location.href, {
                onSuccess: () => {
                    // Inertia's setRecentlySuccessful is only 2 seconds and can not be configured. This is a simple
                    // workaround for showing the success message a bit longer.
                    // TODO: wrap this in some kind of helper hook, so it can be re-used
                    setRecentlySuccessful(true);
                    setTimeout(() => setRecentlySuccessful(false), 6e3);
                    handleReset();
                },
            });
        }
        catch (e) {
            setErrorNotice('Dossierverzoek kon niet worden aangemaakt. Probeer het later nogmaals.');
        }
    };
    return (_jsxs(Layout, { "data-testid": "dossier-create", children: [_jsx(Helmet, { children: _jsx("title", { children: "Dossier aanmaken" }) }), _jsx(H1, { "data-testid": "title", children: "Dossier aanmaken" }), _jsx("form", { action: "./", method: 'post', onSubmit: handleSubmit, children: _jsxs(Panel, { children: [recentlySuccessful && (_jsx(Notice, { type: 'success', text: 'Nieuw dossierverzoek is ontvangen', title: 'Dossierverzoek aangemaakt' })), errorNotice && (_jsx(Notice, { type: 'error', text: errorNotice || '', title: 'Fout' })), _jsxs(Row, { children: [_jsxs(Col, { sm: 5, children: [_jsx(H3, { children: "Gegevens eiser/verzoeker" }), _jsx(ClaimantInfo, { data: data, errors: errors, setData: setData, countryOptions: countryOptions })] }), _jsx(Col, { sm: 1 }), _jsx(Col, { sm: 5, children: _jsxs(Flex, { column: true, children: [_jsx(H3, { children: "Documenten uploaden" }), _jsx(FileUploader, { ref: fileUploaderRef, data: data, setData: setData, errors: errors })] }) })] }), _jsxs(Row, { children: [_jsxs(Col, { sm: 12, className: "mt-2", children: [_jsx(H3, { children: "Gegevens wederpartij" }), _jsxs(Tabs, { children: [_jsxs(TabList, { children: [_jsx(Tab, { onClick: () => {
                                                                setData('type', 'individual');
                                                            }, children: "Natuurlijk persoon" }), _jsx(Tab, { onClick: () => {
                                                                setData('type', 'legal');
                                                            }, children: "Rechtspersoon" })] }), _jsx(TabPanel, { children: _jsx(CounterPartyInfo, { ref: debtorsRef, data: data, errors: errors, setData: setData, countryOptions: countryOptions }) }), _jsx(TabPanel, { children: _jsx(LegalPersons, { data: data, errors: errors, setData: setData, countryOptions: countryOptions }) })] })] }), _jsx(Col, { sm: 12, children: _jsxs(Flex, { column: true, margin: "80px 0 0", children: [_jsx(H3, { children: "Facturen" }), _jsx(Invoices, { ref: invoicesRef, data: data, setData: setData, errors: errors })] }) })] }), _jsx(Flex, { justifyContent: "flex-end", children: _jsx(Button, { type: "submit", secondary: true, isLoading: processing, children: "Aanmaken" }) })] }) })] }));
};
export default Create;
